import { annualReport } from './annual_report';
import { audienceLists } from './audience_lists';
import { chat } from './chat';
import { collections } from './collections';
import { emojis } from './emojis';
import { groups } from './groups';
import { newsItems } from './news_items';
import { pinnedStatuses } from './pinned_statuses';
import { profileEdit } from './profile_edit';
import { shortcuts } from './shortcuts';

export const sliceReducers = {
  annualReport,
  audienceLists,
  chat,
  collections,
  emojis,
  groups,
  newsItems,
  pinnedStatuses,
  profileEdit,
  shortcuts,
};
